import { Dialog, Pane, TextareaField, Button, TextInputField, toaster } from 'evergreen-ui';
import { ConfirmIcon, TrashIcon } from 'evergreen-ui';
import { useState, useEffect } from 'react';
import DiaryService from '../services/diaryService';

const EditDescriptionDialog = ({ isShown, onClose, descriptionEntry, currentUserIsDirector, onSaved }) => {
  const [text, setText] = useState('');
  const [isNarrow, setIsNarrow] = useState(typeof window !== 'undefined' ? window.innerWidth < 560 : false);

  useEffect(() => { if (descriptionEntry) setText(descriptionEntry.testo || ''); }, [descriptionEntry]);

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < 560);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleSave = async () => {
    if (!currentUserIsDirector) { toaster.danger('Permesso negato'); return; }
    try {
      const res = await DiaryService.updateDescription({ id: descriptionEntry.id, testo: text });
      if (res && res.success) {
        toaster.success('Descrizione aggiornata');
        onSaved && onSaved();
        onClose && onClose();
      } else {
        toaster.danger(res.error || 'Errore');
      }
    } catch (e) {
      console.error(e);
      toaster.danger('Errore durante il salvataggio');
    }
  };

  const handleDelete = async () => {
    if (!currentUserIsDirector) {
      toaster.danger('Non hai i permessi');
      return;
    }
    if (!descriptionEntry || !descriptionEntry.id) { toaster.danger('id mancante'); return; }
    if (!window.confirm('Sei sicuro di voler rimuovere questa descrizione giornata? Rimuoverai anche le note correlate?')) return;
    try {
      const res = await DiaryService.deleteDescription(descriptionEntry.id);
      if (res && res.success) {
        toaster.success('Descrizione rimossa');
        onSaved && onSaved();
        onClose && onClose();
      } else {
        toaster.danger(res.error || 'Errore durante la rimozione');
      }
    } catch (e) {
      console.error(e);
      toaster.danger('Errore durante la rimozione');
    }
  };

  return (
    <Dialog isShown={isShown} title="Modifica descrizione giornata" onCloseComplete={onClose} hasFooter={false} shouldAutoFocus={false}>
      <Pane>
        {descriptionEntry && (descriptionEntry.nome || descriptionEntry.cognome) && (
          <Pane marginBottom={8}>
            <TextInputField label="Autore" value={`${descriptionEntry.nome || ''} ${descriptionEntry.cognome || ''}`.trim()} readOnly />
          </Pane>
        )}
        <TextareaField label="Descrizione" value={text} onChange={e => setText(e.target.value)} inputHeight={200} flexibleHeight />
        <Pane display="flex" gap={8} marginTop={8} justifyContent="flex-end" style={{ flexDirection: isNarrow ? 'column' : 'row' }}>
          <Button intent="danger" onClick={handleDelete} style={{ width: isNarrow ? '100%' : 'auto' }}>
            Elimina descrizione <TrashIcon marginLeft={8} />
          </Button>
          <Button appearance="primary" intent="success" onClick={handleSave} style={{ width: isNarrow ? '100%' : 'auto' }}>
            Conferma modifica <ConfirmIcon marginLeft={8} />
          </Button>
        </Pane>
      </Pane>
    </Dialog>
  );
};

export default EditDescriptionDialog;
